import { cloneDeep, uniqueId } from 'lodash-es'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import CSService from '@/modules/continuousService/services/CSService'
import { byId, deleteById, upsertById } from '@/utils/utils'

import { CSAreaId, CSAreaRead, CSAreaWrite } from '@generated/types'

export const useCSAreaStore = defineStore('csAreaStore', () => {
  const csAreas = ref<CSAreaRead[]>([])

  function storeCSArea(csArea: CSAreaRead): CSAreaRead {
    const parsedCSArea = {
      ...csArea,
      inventory: (csArea.inventory || []).map(dayBlocks =>
        dayBlocks.map(block => ({
          ...block,
          id: uniqueId('cs_block_'),
        })),
      ),
    }
    upsertById(cloneDeep(parsedCSArea), csAreas.value)
    return parsedCSArea
  }
  async function fetchAll() {
    const response = await CSService.listAreas()
    response.data.map(storeCSArea)
  }
  async function createCSArea(csArea: CSAreaWrite) {
    const response = await CSService.createCSArea(csArea)
    storeCSArea(response.data)
    if (csArea.photo && csArea.photo instanceof File) {
      await updateCSAreaImage(response.data.id, csArea.photo as File)
    }
    return csAreaById(response.data.id)!
  }
  async function updateCSArea(csArea: CSAreaWrite): Promise<CSAreaRead> {
    if (!csArea.id) throw new Error('CSArea ID is required')
    const response = await CSService.updateCSArea(csArea.id, csArea)
    storeCSArea(response.data)
    if (csArea.photo && csArea.photo instanceof File) {
      await updateCSAreaImage(csArea.id, csArea.photo as File)
    }
    return csAreaById(response.data.id)!
  }
  async function updateCSAreaImage(id: CSAreaId, image: File): Promise<CSAreaRead> {
    let formData = new FormData()
    formData.append('file', image)
    const response = await CSService.updateImage(id, formData)
    return storeCSArea(response.data)
  }
  async function deleteCSArea(id: number): Promise<void> {
    await CSService.deleteCSArea(id)
    deleteById(id, csAreas.value)
  }
  function csAreaById(csAreaId: CSAreaId) {
    return csAreas.value.find(byId(csAreaId))
  }

  return {
    csAreas,
    fetchAll,
    createCSArea,
    updateCSArea,
    csAreaById,
    storeCSArea,
    deleteCSArea,
  }
})
